import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useAuth } from 'contexts/AuthContext';

import { useHistory } from 'react-router-dom';
import { Title } from 'ui/atoms/Title';
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
    const history = useHistory();
    const { currentUser } = useAuth();
    const { t } = useTranslation();
    const [showSowing, setShowSowing] = useState<boolean>(false);
    const [showPickup, setShowPickup] = useState<boolean>(false);

    return (
        <HomeWrapper>
            <ImageContainer>
                <Logo src={process.env.PUBLIC_URL + '/ztocka.jpg'} />
            </ImageContainer>
            <Title text={t('home.title')} subtext={t('home.subtitle')}></Title>
            {currentUser.userType === 'PRIDELOVALEC' && (
                <>
                    <Text>
                        <NavigationButton className="sowing-button" onClick={() => history.push('/sowing')}>
                            <big>{t('home.buttons.createSowing')}</big>
                            <br></br>
                            <small>{t('home.buttons.createSowingDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Text>
                        <NavigationButton className="sowing-button" onClick={() => history.push('/sowingupdate')}>
                            <big>{t('home.buttons.updateSowing')}</big>
                            <br></br>
                            <small>{t('home.buttons.updateSowingDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Text>
                        <NavigationButton className="harvest-button" onClick={() => history.push('/harvest')}>
                            <big>{t('home.buttons.createHarvest')}</big>
                            <br></br>
                            <small>{t('home.buttons.createHarvestDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Text>
                        <NavigationButton className="pickup-button" onClick={() => history.push('/pickup/create')}>
                            <big>{t('home.buttons.createDeliveryNote')}</big>
                            <br></br>
                            <small>{t('home.buttons.createDeliveryNoteDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Text>
                        <NavigationButton className="pickup-button" onClick={() => history.push('/pickup/get')}>
                            <big>{t('home.buttons.preparedDeliveryNote')}</big>
                            <br></br>
                            <small>{t('home.buttons.preparedDeliveryNoteDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Title text={t('home.subGroup.historyTitle')} />
                    <Text>
                        <NavigationButton className="sowing-button" onClick={() => history.push('/sowingfinished')}>
                            <big>{t('home.buttons.completedSowing')}</big>
                            <br></br>
                            <small>{t('home.buttons.completedSowingDesc')}</small>
                        </NavigationButton>
                    </Text>
                    <Text>
                        <NavigationButton className="pickup-button" onClick={() => history.push('/pickup/overview')}>
                            <big>{t('home.buttons.finishedDeliveryNote')}</big>
                            <br></br>
                            <small>{t('home.buttons.finishedDeliveryNoteDesc')}</small>
                        </NavigationButton>
                    </Text>
                </>
            )}
        </HomeWrapper>
    );
};

export default Home;

const NavigationButton = styled.button`
    height: 50px;
    width: 17rem;
    color: #fff;
    background-color: var(--primary);
    border-color: var(--primary);
    margin: 0px 5px 0px 0px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.1rem 0.5rem;
    line-height: 1;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    text-transform: none;

    &:hover:enabled {
        background-color: #2a1ab9;
        border-color: #2819ae;
    }

    &:active {
        background-color: #2819ae;
        border-color: #2517a3;
    }

    &:focus {
        background-color: #2a1ab9;
        border-color: #2819ae;
        box-shadow: 0 0 0 0.2rem rgb(81 65 224 / 50%);
    }

    &:disabled {
        opacity: 0.65;
    }

    &.sowing-button {
        background-color: #6555ed;
    }

    &.harvest-button {
        background-color: #442fff;
    }

    &.pickup-button {
        background-color: #10009b;
    }
`;

const Text = styled.div`
    display: flex;
    justify-content: center;
    font-size: 12pt;
    font-weight: 600;
    padding: 0 0 10px 0;
    @media screen and (max-width: 425px) {
        font-size: 8pt;
    }
    @media screen and (max-width: 768px) {
        font-size: 10pt;
    }
`;

const SubMenu = styled.div`
    padding-left: 40px;
`;

const HomeWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 20px;
    @media screen and (max-width: 425px) {
        margin: 10px;
    }
`;

const StepWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 20px;
`;

const ImageContainer = styled.div`
    display: flex;
    flex: 0 0 56px;
    align-items: center;
    justify-content: center;
`;

const Logo = styled.img`
    width: 25%;
    margin-right: 1px;
    justify-content: center;

    @media screen and (max-width: 768px) {
        width: 50%;
    }
`;
